export default function Footer(){
    return(
        <footer className="footer">
            <div className="footer__wrapper">
                <div className="footer__rigths">
                all rights reserved © 2023
                </div>
            </div>
        </footer>
    )
}